@if (badgeCode) {
  <div class="badge-code-container">
    <div class="badge-code-title">
      <lib-icon class="ticket-icon" icon="ticket" [size]="24"></lib-icon>
      {{ 'ACHIEVEMENTS.you_have_got_coupon_code' | translate }}
    </div>
    <h6 class="coupon-title">{{ badgeCode.couponTitle }}</h6>
    @if (badgeCode.couponDescription) {
      <p class="coupon-description" [innerHTML]="badgeCode.couponDescription | safeHtml"></p>
    }
    <div class="badge-code">
      {{ badgeCode.code }}
      <button mat-flat-button class="button button--small button--transparent" (click)="copy()">
        <lib-icon icon="copy"></lib-icon>
        {{ 'COMMON.copy' | translate}}
      </button>
    </div>
  </div>
}
